// @generated by protoc-gen-es v1.8.0 with parameter "target=ts"
// @generated from file supervisor/v1/environmentopts.proto (package supervisor.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { EnvironmentGitStatus, FileChange } from "../../gitpod/v1/environment_pb.js";

/**
 * WriteMode specifies how WriteFile handles existing files
 *
 * @generated from enum supervisor.v1.WriteMode
 */
export enum WriteMode {
  /**
   * WRITE_MODE_UNSPECIFIED defaults to CREATE_OR_TRUNCATE
   *
   * @generated from enum value: WRITE_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * WRITE_MODE_CREATE fails if the file already exists
   *
   * @generated from enum value: WRITE_MODE_CREATE = 1;
   */
  CREATE = 1,

  /**
   * WRITE_MODE_TRUNCATE overwrites the file, fails if it doesn't exist
   *
   * @generated from enum value: WRITE_MODE_TRUNCATE = 2;
   */
  TRUNCATE = 2,

  /**
   * WRITE_MODE_CREATE_OR_TRUNCATE creates or overwrites the file
   *
   * @generated from enum value: WRITE_MODE_CREATE_OR_TRUNCATE = 3;
   */
  CREATE_OR_TRUNCATE = 3,

  /**
   * WRITE_MODE_APPEND appends to the file, fails if it doesn't exist
   *
   * @generated from enum value: WRITE_MODE_APPEND = 4;
   */
  APPEND = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(WriteMode)
proto3.util.setEnumType(WriteMode, "supervisor.v1.WriteMode", [
  { no: 0, name: "WRITE_MODE_UNSPECIFIED" },
  { no: 1, name: "WRITE_MODE_CREATE" },
  { no: 2, name: "WRITE_MODE_TRUNCATE" },
  { no: 3, name: "WRITE_MODE_CREATE_OR_TRUNCATE" },
  { no: 4, name: "WRITE_MODE_APPEND" },
]);

/**
 * empty for now to allow for future expansion on GetGitStatus rpc
 *
 * @generated from message supervisor.v1.GetGitStatusRequest
 */
export class GetGitStatusRequest extends Message<GetGitStatusRequest> {
  constructor(data?: PartialMessage<GetGitStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitStatusRequest {
    return new GetGitStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitStatusRequest {
    return new GetGitStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitStatusRequest {
    return new GetGitStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitStatusRequest | PlainMessage<GetGitStatusRequest> | undefined, b: GetGitStatusRequest | PlainMessage<GetGitStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetGitStatusRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetGitStatusResponse
 */
export class GetGitStatusResponse extends Message<GetGitStatusResponse> {
  /**
   * @generated from field: gitpod.v1.EnvironmentGitStatus status = 1;
   */
  status?: EnvironmentGitStatus;

  constructor(data?: PartialMessage<GetGitStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "message", T: EnvironmentGitStatus },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitStatusResponse {
    return new GetGitStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitStatusResponse {
    return new GetGitStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitStatusResponse {
    return new GetGitStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitStatusResponse | PlainMessage<GetGitStatusResponse> | undefined, b: GetGitStatusResponse | PlainMessage<GetGitStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetGitStatusResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetGitDiffRequest
 */
export class GetGitDiffRequest extends Message<GetGitDiffRequest> {
  /**
   * path is the relative path of the file to get the diff for
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * this directly maps to the unified parameter (-U) of git diff
   * which controls the number of lines of context around a hunk
   *
   * @generated from field: int32 unified = 2;
   */
  unified = 0;

  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, diffs against HEAD (uncommitted changes only).
   * When set, diffs from merge-base(base_ref, HEAD) to the working tree.
   *
   * @generated from field: string base_ref = 3;
   */
  baseRef = "";

  constructor(data?: PartialMessage<GetGitDiffRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitDiffRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "unified", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "base_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitDiffRequest {
    return new GetGitDiffRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitDiffRequest {
    return new GetGitDiffRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitDiffRequest {
    return new GetGitDiffRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitDiffRequest | PlainMessage<GetGitDiffRequest> | undefined, b: GetGitDiffRequest | PlainMessage<GetGitDiffRequest> | undefined): boolean {
    return proto3.util.equals(GetGitDiffRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetGitDiffResponse
 */
export class GetGitDiffResponse extends Message<GetGitDiffResponse> {
  /**
   * file_change is the current file change for the requested file at time of request
   *
   * @generated from field: gitpod.v1.FileChange file_change = 1;
   */
  fileChange?: FileChange;

  /**
   * hunks is the list of hunks for the requested file at time of request
   *
   * @generated from field: repeated supervisor.v1.GitHunk hunks = 2;
   */
  hunks: GitHunk[] = [];

  /**
   * is_binary is true when the file is detected as binary (e.g. images, fonts).
   * When true, hunks will be empty.
   *
   * @generated from field: bool is_binary = 3;
   */
  isBinary = false;

  constructor(data?: PartialMessage<GetGitDiffResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitDiffResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_change", kind: "message", T: FileChange },
    { no: 2, name: "hunks", kind: "message", T: GitHunk, repeated: true },
    { no: 3, name: "is_binary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitDiffResponse {
    return new GetGitDiffResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitDiffResponse {
    return new GetGitDiffResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitDiffResponse {
    return new GetGitDiffResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitDiffResponse | PlainMessage<GetGitDiffResponse> | undefined, b: GetGitDiffResponse | PlainMessage<GetGitDiffResponse> | undefined): boolean {
    return proto3.util.equals(GetGitDiffResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GitHunk
 */
export class GitHunk extends Message<GitHunk> {
  /**
   * starting line number in original file
   *
   * @generated from field: int32 original_start_line = 1;
   */
  originalStartLine = 0;

  /**
   * number of lines the hunk applies to in the original file
   *
   * @generated from field: int32 original_lines = 2;
   */
  originalLines = 0;

  /**
   * if > 0, then the original file had a 'No newline at end of file' mark at this offset
   *
   * @generated from field: int32 original_no_newline_at = 3;
   */
  originalNoNewlineAt = 0;

  /**
   * starting line number in new file
   *
   * @generated from field: int32 new_start_line = 4;
   */
  newStartLine = 0;

  /**
   * number of lines the hunk applies to in the new file
   *
   * @generated from field: int32 new_lines = 5;
   */
  newLines = 0;

  /**
   * optional section heading
   *
   * @generated from field: string section = 6;
   */
  section = "";

  /**
   * 0-indexed line offset in unified file diff (including section headers); this is
   * only set when Hunks are read from entire file diff (i.e., when ReadAllHunks is
   * called) This accounts for hunk headers, too, so the StartPosition of the first
   * hunk will be 1.
   *
   * @generated from field: int32 start_position = 7;
   */
  startPosition = 0;

  /**
   * hunk body (lines prefixed with '-', '+', or ' '
   *
   * @generated from field: string body = 8;
   */
  body = "";

  constructor(data?: PartialMessage<GitHunk>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GitHunk";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "original_start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "original_lines", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "original_no_newline_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "new_start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "new_lines", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "section", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "start_position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GitHunk {
    return new GitHunk().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GitHunk {
    return new GitHunk().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GitHunk {
    return new GitHunk().fromJsonString(jsonString, options);
  }

  static equals(a: GitHunk | PlainMessage<GitHunk> | undefined, b: GitHunk | PlainMessage<GitHunk> | undefined): boolean {
    return proto3.util.equals(GitHunk, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetFileDiffContentRequest
 */
export class GetFileDiffContentRequest extends Message<GetFileDiffContentRequest> {
  /**
   * path is the relative path of the file to get content for
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * include_binary_content, when true, instructs the server to return
   * original_content and new_content even for binary files. By default
   * binary files only set is_binary without content to avoid unnecessary reads.
   *
   * @generated from field: bool include_binary_content = 2;
   */
  includeBinaryContent = false;

  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, original_content comes from HEAD (uncommitted changes only).
   * When set, original_content comes from merge-base(base_ref, HEAD).
   *
   * @generated from field: string base_ref = 3;
   */
  baseRef = "";

  constructor(data?: PartialMessage<GetFileDiffContentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetFileDiffContentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "include_binary_content", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "base_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFileDiffContentRequest {
    return new GetFileDiffContentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFileDiffContentRequest {
    return new GetFileDiffContentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFileDiffContentRequest {
    return new GetFileDiffContentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetFileDiffContentRequest | PlainMessage<GetFileDiffContentRequest> | undefined, b: GetFileDiffContentRequest | PlainMessage<GetFileDiffContentRequest> | undefined): boolean {
    return proto3.util.equals(GetFileDiffContentRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetFileDiffContentResponse
 */
export class GetFileDiffContentResponse extends Message<GetFileDiffContentResponse> {
  /**
   * file_change describes the type of change (added, modified, deleted, etc.)
   *
   * @generated from field: gitpod.v1.FileChange file_change = 1;
   */
  fileChange?: FileChange;

  /**
   * original_content is the file content from HEAD/index (empty for new files)
   *
   * @generated from field: bytes original_content = 2;
   */
  originalContent = new Uint8Array(0);

  /**
   * new_content is the current working tree content (empty for deleted files)
   *
   * @generated from field: bytes new_content = 3;
   */
  newContent = new Uint8Array(0);

  /**
   * is_binary is true when the file is detected as binary (e.g. images, fonts).
   * When include_binary_content is not set, original_content and new_content
   * will be empty for binary files.
   *
   * @generated from field: bool is_binary = 4;
   */
  isBinary = false;

  constructor(data?: PartialMessage<GetFileDiffContentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetFileDiffContentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_change", kind: "message", T: FileChange },
    { no: 2, name: "original_content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "new_content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "is_binary", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetFileDiffContentResponse {
    return new GetFileDiffContentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetFileDiffContentResponse {
    return new GetFileDiffContentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetFileDiffContentResponse {
    return new GetFileDiffContentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetFileDiffContentResponse | PlainMessage<GetFileDiffContentResponse> | undefined, b: GetFileDiffContentResponse | PlainMessage<GetFileDiffContentResponse> | undefined): boolean {
    return proto3.util.equals(GetFileDiffContentResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetGitDiffFilesRequest
 */
export class GetGitDiffFilesRequest extends Message<GetGitDiffFilesRequest> {
  /**
   * base_ref is the git ref to diff against (e.g. "origin/main").
   * When empty, defaults to HEAD and returns uncommitted changes
   * (equivalent to GetGitStatus changed_files).
   * When set, returns all files changed between merge-base(base_ref, HEAD)
   * and the current working tree (committed + uncommitted).
   *
   * @generated from field: string base_ref = 1;
   */
  baseRef = "";

  constructor(data?: PartialMessage<GetGitDiffFilesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitDiffFilesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "base_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitDiffFilesRequest {
    return new GetGitDiffFilesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitDiffFilesRequest {
    return new GetGitDiffFilesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitDiffFilesRequest {
    return new GetGitDiffFilesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitDiffFilesRequest | PlainMessage<GetGitDiffFilesRequest> | undefined, b: GetGitDiffFilesRequest | PlainMessage<GetGitDiffFilesRequest> | undefined): boolean {
    return proto3.util.equals(GetGitDiffFilesRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetGitDiffFilesResponse
 */
export class GetGitDiffFilesResponse extends Message<GetGitDiffFilesResponse> {
  /**
   * changed_files is the list of files that differ between the base ref
   * and the current working tree.
   *
   * @generated from field: repeated gitpod.v1.FileChange changed_files = 1;
   */
  changedFiles: FileChange[] = [];

  /**
   * total_changed_files is the total count of changed files.
   *
   * @generated from field: int32 total_changed_files = 2;
   */
  totalChangedFiles = 0;

  constructor(data?: PartialMessage<GetGitDiffFilesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetGitDiffFilesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "changed_files", kind: "message", T: FileChange, repeated: true },
    { no: 2, name: "total_changed_files", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetGitDiffFilesResponse {
    return new GetGitDiffFilesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetGitDiffFilesResponse {
    return new GetGitDiffFilesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetGitDiffFilesResponse {
    return new GetGitDiffFilesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetGitDiffFilesResponse | PlainMessage<GetGitDiffFilesResponse> | undefined, b: GetGitDiffFilesResponse | PlainMessage<GetGitDiffFilesResponse> | undefined): boolean {
    return proto3.util.equals(GetGitDiffFilesResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetDefaultBranchRequest
 */
export class GetDefaultBranchRequest extends Message<GetDefaultBranchRequest> {
  constructor(data?: PartialMessage<GetDefaultBranchRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetDefaultBranchRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDefaultBranchRequest {
    return new GetDefaultBranchRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDefaultBranchRequest {
    return new GetDefaultBranchRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDefaultBranchRequest {
    return new GetDefaultBranchRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDefaultBranchRequest | PlainMessage<GetDefaultBranchRequest> | undefined, b: GetDefaultBranchRequest | PlainMessage<GetDefaultBranchRequest> | undefined): boolean {
    return proto3.util.equals(GetDefaultBranchRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.GetDefaultBranchResponse
 */
export class GetDefaultBranchResponse extends Message<GetDefaultBranchResponse> {
  /**
   * branch is the name of the default branch (e.g. "main").
   *
   * @generated from field: string branch = 1;
   */
  branch = "";

  constructor(data?: PartialMessage<GetDefaultBranchResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.GetDefaultBranchResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDefaultBranchResponse {
    return new GetDefaultBranchResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDefaultBranchResponse {
    return new GetDefaultBranchResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDefaultBranchResponse {
    return new GetDefaultBranchResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDefaultBranchResponse | PlainMessage<GetDefaultBranchResponse> | undefined, b: GetDefaultBranchResponse | PlainMessage<GetDefaultBranchResponse> | undefined): boolean {
    return proto3.util.equals(GetDefaultBranchResponse, a, b);
  }
}

/**
 * FindRequest specifies criteria for finding files and directories.
 * The response is limited to 65536 entries maximum.
 *
 * @generated from message supervisor.v1.FindRequest
 */
export class FindRequest extends Message<FindRequest> {
  /**
   * path is the starting directory for the search.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * pattern is a glob pattern to match file/directory names
   *
   * @generated from field: string pattern = 2;
   */
  pattern = "";

  /**
   * type filters results by file type
   *
   * @generated from field: supervisor.v1.FindRequest.FileType type = 3;
   */
  type = FindRequest_FileType.UNSPECIFIED;

  /**
   * max_depth limits how deep to search (0 = unlimited)
   *
   * @generated from field: int32 max_depth = 4;
   */
  maxDepth = 0;

  constructor(data?: PartialMessage<FindRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.FindRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pattern", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(FindRequest_FileType) },
    { no: 4, name: "max_depth", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FindRequest {
    return new FindRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FindRequest {
    return new FindRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FindRequest {
    return new FindRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FindRequest | PlainMessage<FindRequest> | undefined, b: FindRequest | PlainMessage<FindRequest> | undefined): boolean {
    return proto3.util.equals(FindRequest, a, b);
  }
}

/**
 * @generated from enum supervisor.v1.FindRequest.FileType
 */
export enum FindRequest_FileType {
  /**
   * @generated from enum value: FILE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILE_TYPE_FILE = 1;
   */
  FILE = 1,

  /**
   * @generated from enum value: FILE_TYPE_DIRECTORY = 2;
   */
  DIRECTORY = 2,

  /**
   * @generated from enum value: FILE_TYPE_ANY = 3;
   */
  ANY = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(FindRequest_FileType)
proto3.util.setEnumType(FindRequest_FileType, "supervisor.v1.FindRequest.FileType", [
  { no: 0, name: "FILE_TYPE_UNSPECIFIED" },
  { no: 1, name: "FILE_TYPE_FILE" },
  { no: 2, name: "FILE_TYPE_DIRECTORY" },
  { no: 3, name: "FILE_TYPE_ANY" },
]);

/**
 * @generated from message supervisor.v1.FindResponse
 */
export class FindResponse extends Message<FindResponse> {
  /**
   * files contains matching entries, limited to 65536 maximum.
   * If truncated is true, more entries exist but were not returned.
   *
   * @generated from field: repeated supervisor.v1.FileInfo files = 1;
   */
  files: FileInfo[] = [];

  /**
   * truncated indicates the result was limited due to exceeding 65536 entries
   *
   * @generated from field: bool truncated = 2;
   */
  truncated = false;

  constructor(data?: PartialMessage<FindResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.FindResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "files", kind: "message", T: FileInfo, repeated: true },
    { no: 2, name: "truncated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FindResponse {
    return new FindResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FindResponse {
    return new FindResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FindResponse {
    return new FindResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FindResponse | PlainMessage<FindResponse> | undefined, b: FindResponse | PlainMessage<FindResponse> | undefined): boolean {
    return proto3.util.equals(FindResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.FileInfo
 */
export class FileInfo extends Message<FileInfo> {
  /**
   * path is the absolute path
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * is_directory indicates if this is a directory
   *
   * @generated from field: bool is_directory = 2;
   */
  isDirectory = false;

  /**
   * size is the file size in bytes (0 for directories)
   *
   * @generated from field: int64 size = 3;
   */
  size = protoInt64.zero;

  constructor(data?: PartialMessage<FileInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.FileInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_directory", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FileInfo {
    return new FileInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FileInfo {
    return new FileInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FileInfo {
    return new FileInfo().fromJsonString(jsonString, options);
  }

  static equals(a: FileInfo | PlainMessage<FileInfo> | undefined, b: FileInfo | PlainMessage<FileInfo> | undefined): boolean {
    return proto3.util.equals(FileInfo, a, b);
  }
}

/**
 * ReadFileRequest reads file content or lists directory entries
 *
 * @generated from message supervisor.v1.ReadFileRequest
 */
export class ReadFileRequest extends Message<ReadFileRequest> {
  /**
   * path is the path to the file or directory.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * offset is the byte offset to start reading from (ignored for directories)
   *
   * @generated from field: int64 offset = 2;
   */
  offset = protoInt64.zero;

  /**
   * length is the maximum number of bytes to read (0 = read all, ignored for directories)
   *
   * @generated from field: int64 length = 3;
   */
  length = protoInt64.zero;

  constructor(data?: PartialMessage<ReadFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ReadFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "length", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadFileRequest {
    return new ReadFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadFileRequest {
    return new ReadFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadFileRequest {
    return new ReadFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReadFileRequest | PlainMessage<ReadFileRequest> | undefined, b: ReadFileRequest | PlainMessage<ReadFileRequest> | undefined): boolean {
    return proto3.util.equals(ReadFileRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ReadFileResponse
 */
export class ReadFileResponse extends Message<ReadFileResponse> {
  /**
   * @generated from oneof supervisor.v1.ReadFileResponse.result
   */
  result: {
    /**
     * content is returned when reading a file
     *
     * @generated from field: supervisor.v1.FileContent content = 1;
     */
    value: FileContent;
    case: "content";
  } | {
    /**
     * directory is returned when path is a directory
     *
     * @generated from field: supervisor.v1.DirectoryListing directory = 2;
     */
    value: DirectoryListing;
    case: "directory";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<ReadFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ReadFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "message", T: FileContent, oneof: "result" },
    { no: 2, name: "directory", kind: "message", T: DirectoryListing, oneof: "result" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadFileResponse {
    return new ReadFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadFileResponse {
    return new ReadFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadFileResponse {
    return new ReadFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReadFileResponse | PlainMessage<ReadFileResponse> | undefined, b: ReadFileResponse | PlainMessage<ReadFileResponse> | undefined): boolean {
    return proto3.util.equals(ReadFileResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.FileContent
 */
export class FileContent extends Message<FileContent> {
  /**
   * data is the file content
   *
   * @generated from field: bytes data = 1;
   */
  data = new Uint8Array(0);

  /**
   * total_size is the total file size in bytes
   *
   * @generated from field: int64 total_size = 2;
   */
  totalSize = protoInt64.zero;

  /**
   * content_hash is the SHA-256 hash of the returned data (hex encoded)
   *
   * @generated from field: string content_hash = 3;
   */
  contentHash = "";

  constructor(data?: PartialMessage<FileContent>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.FileContent";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "total_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "content_hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FileContent {
    return new FileContent().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FileContent {
    return new FileContent().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FileContent {
    return new FileContent().fromJsonString(jsonString, options);
  }

  static equals(a: FileContent | PlainMessage<FileContent> | undefined, b: FileContent | PlainMessage<FileContent> | undefined): boolean {
    return proto3.util.equals(FileContent, a, b);
  }
}

/**
 * @generated from message supervisor.v1.DirectoryListing
 */
export class DirectoryListing extends Message<DirectoryListing> {
  /**
   * @generated from field: repeated supervisor.v1.FileInfo entries = 1;
   */
  entries: FileInfo[] = [];

  constructor(data?: PartialMessage<DirectoryListing>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.DirectoryListing";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "entries", kind: "message", T: FileInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DirectoryListing {
    return new DirectoryListing().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DirectoryListing {
    return new DirectoryListing().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DirectoryListing {
    return new DirectoryListing().fromJsonString(jsonString, options);
  }

  static equals(a: DirectoryListing | PlainMessage<DirectoryListing> | undefined, b: DirectoryListing | PlainMessage<DirectoryListing> | undefined): boolean {
    return proto3.util.equals(DirectoryListing, a, b);
  }
}

/**
 * WriteFileRequest writes content to a file
 *
 * @generated from message supervisor.v1.WriteFileRequest
 */
export class WriteFileRequest extends Message<WriteFileRequest> {
  /**
   * path is the path to the file.
   * Absolute paths (starting with /) resolve to filesystem root.
   * Relative paths resolve relative to the workspace folder.
   *
   * @generated from field: string path = 1;
   */
  path = "";

  /**
   * content is the data to write
   *
   * @generated from field: bytes content = 2;
   */
  content = new Uint8Array(0);

  /**
   * mode specifies how to handle existing files
   *
   * @generated from field: supervisor.v1.WriteMode mode = 3;
   */
  mode = WriteMode.UNSPECIFIED;

  constructor(data?: PartialMessage<WriteFileRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.WriteFileRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "mode", kind: "enum", T: proto3.getEnumType(WriteMode) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WriteFileRequest {
    return new WriteFileRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WriteFileRequest {
    return new WriteFileRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WriteFileRequest {
    return new WriteFileRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WriteFileRequest | PlainMessage<WriteFileRequest> | undefined, b: WriteFileRequest | PlainMessage<WriteFileRequest> | undefined): boolean {
    return proto3.util.equals(WriteFileRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.WriteFileResponse
 */
export class WriteFileResponse extends Message<WriteFileResponse> {
  /**
   * bytes_written is the number of bytes written
   *
   * @generated from field: int64 bytes_written = 1;
   */
  bytesWritten = protoInt64.zero;

  constructor(data?: PartialMessage<WriteFileResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.WriteFileResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bytes_written", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WriteFileResponse {
    return new WriteFileResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WriteFileResponse {
    return new WriteFileResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WriteFileResponse {
    return new WriteFileResponse().fromJsonString(jsonString, options);
  }

  static equals(a: WriteFileResponse | PlainMessage<WriteFileResponse> | undefined, b: WriteFileResponse | PlainMessage<WriteFileResponse> | undefined): boolean {
    return proto3.util.equals(WriteFileResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.CreateTerminalRequest
 */
export class CreateTerminalRequest extends Message<CreateTerminalRequest> {
  /**
   * shell is the shell to use (e.g., "/bin/bash"). If empty, uses the user's default shell.
   *
   * @generated from field: string shell = 1;
   */
  shell = "";

  /**
   * working_directory is the initial working directory. If empty, uses the workspace folder.
   *
   * @generated from field: string working_directory = 2;
   */
  workingDirectory = "";

  /**
   * initial_cols is the initial number of columns (default: 80)
   *
   * @generated from field: uint32 initial_cols = 3;
   */
  initialCols = 0;

  /**
   * initial_rows is the initial number of rows (default: 24)
   *
   * @generated from field: uint32 initial_rows = 4;
   */
  initialRows = 0;

  /**
   * env is additional environment variables to set
   *
   * @generated from field: map<string, string> env = 5;
   */
  env: { [key: string]: string } = {};

  constructor(data?: PartialMessage<CreateTerminalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CreateTerminalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shell", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "working_directory", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "initial_cols", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "initial_rows", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "env", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTerminalRequest {
    return new CreateTerminalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTerminalRequest {
    return new CreateTerminalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTerminalRequest {
    return new CreateTerminalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTerminalRequest | PlainMessage<CreateTerminalRequest> | undefined, b: CreateTerminalRequest | PlainMessage<CreateTerminalRequest> | undefined): boolean {
    return proto3.util.equals(CreateTerminalRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.CreateTerminalResponse
 */
export class CreateTerminalResponse extends Message<CreateTerminalResponse> {
  /**
   * terminal_id is the unique identifier for the created terminal
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  constructor(data?: PartialMessage<CreateTerminalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CreateTerminalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTerminalResponse {
    return new CreateTerminalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTerminalResponse {
    return new CreateTerminalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTerminalResponse {
    return new CreateTerminalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTerminalResponse | PlainMessage<CreateTerminalResponse> | undefined, b: CreateTerminalResponse | PlainMessage<CreateTerminalResponse> | undefined): boolean {
    return proto3.util.equals(CreateTerminalResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ReadTerminalRequest
 */
export class ReadTerminalRequest extends Message<ReadTerminalRequest> {
  /**
   * terminal_id is the terminal to read from
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  /**
   * skip_history, when true, skips sending the scrollback buffer.
   * Use on reconnection to avoid duplicate content.
   *
   * @generated from field: bool skip_history = 2;
   */
  skipHistory = false;

  constructor(data?: PartialMessage<ReadTerminalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ReadTerminalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "skip_history", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadTerminalRequest {
    return new ReadTerminalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadTerminalRequest {
    return new ReadTerminalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadTerminalRequest {
    return new ReadTerminalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ReadTerminalRequest | PlainMessage<ReadTerminalRequest> | undefined, b: ReadTerminalRequest | PlainMessage<ReadTerminalRequest> | undefined): boolean {
    return proto3.util.equals(ReadTerminalRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ReadTerminalResponse
 */
export class ReadTerminalResponse extends Message<ReadTerminalResponse> {
  /**
   * data is the terminal output
   *
   * @generated from field: bytes data = 1;
   */
  data = new Uint8Array(0);

  constructor(data?: PartialMessage<ReadTerminalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ReadTerminalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadTerminalResponse {
    return new ReadTerminalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadTerminalResponse {
    return new ReadTerminalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadTerminalResponse {
    return new ReadTerminalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ReadTerminalResponse | PlainMessage<ReadTerminalResponse> | undefined, b: ReadTerminalResponse | PlainMessage<ReadTerminalResponse> | undefined): boolean {
    return proto3.util.equals(ReadTerminalResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.WriteTerminalRequest
 */
export class WriteTerminalRequest extends Message<WriteTerminalRequest> {
  /**
   * terminal_id is the terminal to write to
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  /**
   * data is the input to send to the terminal
   *
   * @generated from field: bytes data = 2;
   */
  data = new Uint8Array(0);

  constructor(data?: PartialMessage<WriteTerminalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.WriteTerminalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WriteTerminalRequest {
    return new WriteTerminalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WriteTerminalRequest {
    return new WriteTerminalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WriteTerminalRequest {
    return new WriteTerminalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: WriteTerminalRequest | PlainMessage<WriteTerminalRequest> | undefined, b: WriteTerminalRequest | PlainMessage<WriteTerminalRequest> | undefined): boolean {
    return proto3.util.equals(WriteTerminalRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.WriteTerminalResponse
 */
export class WriteTerminalResponse extends Message<WriteTerminalResponse> {
  constructor(data?: PartialMessage<WriteTerminalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.WriteTerminalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): WriteTerminalResponse {
    return new WriteTerminalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): WriteTerminalResponse {
    return new WriteTerminalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): WriteTerminalResponse {
    return new WriteTerminalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: WriteTerminalResponse | PlainMessage<WriteTerminalResponse> | undefined, b: WriteTerminalResponse | PlainMessage<WriteTerminalResponse> | undefined): boolean {
    return proto3.util.equals(WriteTerminalResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ResizeTerminalRequest
 */
export class ResizeTerminalRequest extends Message<ResizeTerminalRequest> {
  /**
   * terminal_id is the terminal to resize
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  /**
   * cols is the new number of columns
   *
   * @generated from field: uint32 cols = 2;
   */
  cols = 0;

  /**
   * rows is the new number of rows
   *
   * @generated from field: uint32 rows = 3;
   */
  rows = 0;

  constructor(data?: PartialMessage<ResizeTerminalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ResizeTerminalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cols", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "rows", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResizeTerminalRequest {
    return new ResizeTerminalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResizeTerminalRequest {
    return new ResizeTerminalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResizeTerminalRequest {
    return new ResizeTerminalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ResizeTerminalRequest | PlainMessage<ResizeTerminalRequest> | undefined, b: ResizeTerminalRequest | PlainMessage<ResizeTerminalRequest> | undefined): boolean {
    return proto3.util.equals(ResizeTerminalRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ResizeTerminalResponse
 */
export class ResizeTerminalResponse extends Message<ResizeTerminalResponse> {
  constructor(data?: PartialMessage<ResizeTerminalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ResizeTerminalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ResizeTerminalResponse {
    return new ResizeTerminalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ResizeTerminalResponse {
    return new ResizeTerminalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ResizeTerminalResponse {
    return new ResizeTerminalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ResizeTerminalResponse | PlainMessage<ResizeTerminalResponse> | undefined, b: ResizeTerminalResponse | PlainMessage<ResizeTerminalResponse> | undefined): boolean {
    return proto3.util.equals(ResizeTerminalResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.CloseTerminalRequest
 */
export class CloseTerminalRequest extends Message<CloseTerminalRequest> {
  /**
   * terminal_id is the terminal to close
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  constructor(data?: PartialMessage<CloseTerminalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CloseTerminalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseTerminalRequest {
    return new CloseTerminalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseTerminalRequest {
    return new CloseTerminalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseTerminalRequest {
    return new CloseTerminalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CloseTerminalRequest | PlainMessage<CloseTerminalRequest> | undefined, b: CloseTerminalRequest | PlainMessage<CloseTerminalRequest> | undefined): boolean {
    return proto3.util.equals(CloseTerminalRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.CloseTerminalResponse
 */
export class CloseTerminalResponse extends Message<CloseTerminalResponse> {
  constructor(data?: PartialMessage<CloseTerminalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CloseTerminalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CloseTerminalResponse {
    return new CloseTerminalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CloseTerminalResponse {
    return new CloseTerminalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CloseTerminalResponse {
    return new CloseTerminalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CloseTerminalResponse | PlainMessage<CloseTerminalResponse> | undefined, b: CloseTerminalResponse | PlainMessage<CloseTerminalResponse> | undefined): boolean {
    return proto3.util.equals(CloseTerminalResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ListTerminalsRequest
 */
export class ListTerminalsRequest extends Message<ListTerminalsRequest> {
  constructor(data?: PartialMessage<ListTerminalsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ListTerminalsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTerminalsRequest {
    return new ListTerminalsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTerminalsRequest {
    return new ListTerminalsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTerminalsRequest {
    return new ListTerminalsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListTerminalsRequest | PlainMessage<ListTerminalsRequest> | undefined, b: ListTerminalsRequest | PlainMessage<ListTerminalsRequest> | undefined): boolean {
    return proto3.util.equals(ListTerminalsRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ListTerminalsResponse
 */
export class ListTerminalsResponse extends Message<ListTerminalsResponse> {
  /**
   * @generated from field: repeated supervisor.v1.TerminalInfo terminals = 1;
   */
  terminals: TerminalInfo[] = [];

  constructor(data?: PartialMessage<ListTerminalsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ListTerminalsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminals", kind: "message", T: TerminalInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListTerminalsResponse {
    return new ListTerminalsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListTerminalsResponse {
    return new ListTerminalsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListTerminalsResponse {
    return new ListTerminalsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListTerminalsResponse | PlainMessage<ListTerminalsResponse> | undefined, b: ListTerminalsResponse | PlainMessage<ListTerminalsResponse> | undefined): boolean {
    return proto3.util.equals(ListTerminalsResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.TerminalInfo
 */
export class TerminalInfo extends Message<TerminalInfo> {
  /**
   * terminal_id is the unique identifier
   *
   * @generated from field: string terminal_id = 1;
   */
  terminalId = "";

  /**
   * shell is the shell being used
   *
   * @generated from field: string shell = 2;
   */
  shell = "";

  /**
   * working_directory is the current working directory
   *
   * @generated from field: string working_directory = 3;
   */
  workingDirectory = "";

  /**
   * cols is the current number of columns
   *
   * @generated from field: uint32 cols = 4;
   */
  cols = 0;

  /**
   * rows is the current number of rows
   *
   * @generated from field: uint32 rows = 5;
   */
  rows = 0;

  /**
   * created_at is when the terminal was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  constructor(data?: PartialMessage<TerminalInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.TerminalInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shell", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "working_directory", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cols", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "rows", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TerminalInfo {
    return new TerminalInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TerminalInfo {
    return new TerminalInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TerminalInfo {
    return new TerminalInfo().fromJsonString(jsonString, options);
  }

  static equals(a: TerminalInfo | PlainMessage<TerminalInfo> | undefined, b: TerminalInfo | PlainMessage<TerminalInfo> | undefined): boolean {
    return proto3.util.equals(TerminalInfo, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ExecRequest
 */
export class ExecRequest extends Message<ExecRequest> {
  /**
   * operation_id is the idempotency key (typically tool_call_id from LLM)
   * Same ID returns cached result if operation completed
   *
   * @generated from field: string operation_id = 1;
   */
  operationId = "";

  /**
   * command is the shell command to execute (run via sh -c)
   *
   * @generated from field: string command = 2;
   */
  command = "";

  /**
   * working_directory (optional, defaults to workspace folder)
   *
   * @generated from field: string working_directory = 3;
   */
  workingDirectory = "";

  /**
   * timeout_seconds for command execution (default: 120, 0 = no timeout)
   *
   * @generated from field: int32 timeout_seconds = 4;
   */
  timeoutSeconds = 0;

  constructor(data?: PartialMessage<ExecRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ExecRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "working_directory", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "timeout_seconds", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExecRequest {
    return new ExecRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExecRequest {
    return new ExecRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExecRequest {
    return new ExecRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExecRequest | PlainMessage<ExecRequest> | undefined, b: ExecRequest | PlainMessage<ExecRequest> | undefined): boolean {
    return proto3.util.equals(ExecRequest, a, b);
  }
}

/**
 * @generated from message supervisor.v1.ExecResponse
 */
export class ExecResponse extends Message<ExecResponse> {
  /**
   * exit_code of the command (0 = success)
   *
   * @generated from field: int32 exit_code = 1;
   */
  exitCode = 0;

  /**
   * stdout output
   *
   * @generated from field: string stdout = 2;
   */
  stdout = "";

  /**
   * stderr output
   *
   * @generated from field: string stderr = 3;
   */
  stderr = "";

  constructor(data?: PartialMessage<ExecResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.ExecResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "exit_code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "stdout", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "stderr", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExecResponse {
    return new ExecResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExecResponse {
    return new ExecResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExecResponse {
    return new ExecResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExecResponse | PlainMessage<ExecResponse> | undefined, b: ExecResponse | PlainMessage<ExecResponse> | undefined): boolean {
    return proto3.util.equals(ExecResponse, a, b);
  }
}

/**
 * @generated from message supervisor.v1.CancelExecRequest
 */
export class CancelExecRequest extends Message<CancelExecRequest> {
  /**
   * operation_id of the operation to cancel
   *
   * @generated from field: string operation_id = 1;
   */
  operationId = "";

  constructor(data?: PartialMessage<CancelExecRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CancelExecRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "operation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelExecRequest {
    return new CancelExecRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelExecRequest {
    return new CancelExecRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelExecRequest {
    return new CancelExecRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CancelExecRequest | PlainMessage<CancelExecRequest> | undefined, b: CancelExecRequest | PlainMessage<CancelExecRequest> | undefined): boolean {
    return proto3.util.equals(CancelExecRequest, a, b);
  }
}

/**
 * Empty - cancellation is fire-and-forget
 * If operation was running, it's now cancelled
 * If already done or not found, no-op
 *
 * @generated from message supervisor.v1.CancelExecResponse
 */
export class CancelExecResponse extends Message<CancelExecResponse> {
  constructor(data?: PartialMessage<CancelExecResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "supervisor.v1.CancelExecResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CancelExecResponse {
    return new CancelExecResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CancelExecResponse {
    return new CancelExecResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CancelExecResponse {
    return new CancelExecResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CancelExecResponse | PlainMessage<CancelExecResponse> | undefined, b: CancelExecResponse | PlainMessage<CancelExecResponse> | undefined): boolean {
    return proto3.util.equals(CancelExecResponse, a, b);
  }
}

